/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Utils\pricing.utils.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday August 14th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday August 14th 2024 4:47:40 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { PriceListsByType, PricingType } from "Type/pricing.type";

export default function formatPricing(data: PricingType[]) {
    const result: PriceListsByType = data.reduce((acc: PriceListsByType, curr: PricingType) => {
        const typeKey = curr.Type;
        if (!acc[typeKey][curr.Mileage])
            acc[typeKey][curr.Mileage] = {};

        acc[typeKey][curr.Mileage][curr.Month] = curr.Amount;
        return acc;
    }, { LOA: {}, LLD: {} });
    return result;
};
